import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {CoinsService_GetCoinsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {useCustomerSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../features/ReductionsState/useReductionsStateRequestParameter';

export const useGetCoins = () => {
  const customerSession = useCustomerSession();

  return useGrpcRequest(
    CoinsService_GetCoinsLazy,
    {
      session: customerSession!,
      reductionsState: useReductionsStateRequestParameter(),
    },
    {disabled: !customerSession},
  );
};
